/**
 * EVO — bildirishnomalar klienti.
 *
 * Server tomoni: `apps/api/src/modules/notifications`. Skaner hodisalarni
 * topib navbatga yozadi, dispatcher esa kanallarga (Telegram, in-app)
 * tarqatadi. Bu fayl IN-APP tomonini ochadi.
 */
import { api } from './api';

export interface NotificationRow {
  readonly id: number;
  readonly templateCode: string;
  readonly title: string;
  /** Serverda tayyorlangan MATN — ekranda qayta formatlanmaydi. */
  readonly text: string;
  readonly status: string;
  readonly createdAt: string;
  readonly sentAt: string | null;
  readonly readAt: string | null;
}

export const notificationKeys = {
  all: ['notifications'] as const,
  unread: ['notifications', 'unread'] as const,
  list: ['notifications', 'list'] as const,
};

export const fetchUnreadCount = (signal?: AbortSignal): Promise<{ readonly unread: number }> =>
  api.get<{ readonly unread: number }>('/notifications/unread-count', { signal });

export const fetchNotifications = (
  signal?: AbortSignal,
): Promise<{ readonly items: readonly NotificationRow[] }> =>
  api.get<{ readonly items: readonly NotificationRow[] }>('/notifications', {
    query: { page: 1, pageSize: 20 },
    signal,
  });

export const markRead = (id: number): Promise<unknown> =>
  api.put<unknown>(`/notifications/${id}/read`, {});

export const markAllRead = (): Promise<unknown> => api.put<unknown>('/notifications/read-all', {});
